<template>
  <div class="tile is-ancestor" v-if="occurrence">
    <div class="is-parent">
      <div class="is-half column">
        <article class="tile is-child box">
          <h4 class="title">Ticket <span v-if="parseInt(occurrence.type) == 2">Internal</span></h4>
          <div class="columns is-multiline">
            <div class="column is-12">
              <div class="card is-fullwidth" style="box-shadow: 0 2px 3px #A71C20, 0 0 0 1px #A71C20;">
                <header class="card-header is-primary" style="box-shadow: 0 1px 0px #A71C20, 0 0 0 0px #A71C20; background-color: #A71C20;">
                  <p class="card-header-title is-primary" style="color: #FFFFFF;">#{{ occurrence.id }} - {{ occurrence.subject }}</p>
                </header>
                <div class="card-content">
                  <div class="content">
                    <article class="media">
                      <p>
                        <b>Department:</b> {{ parseDepartament(occurrence.departament)}}<br/>
                        <b>Status:</b> {{ parseStatus(occurrence.status) }}<br/>
                      </p>
                    </article>
                    <article class="media">
                      <pre>{{ occurrence.occurrence }}</pre>
                    </article>
                    <article class="media" v-if="occurrence.files.length > 0">
                      <template v-if="showFiles == false">
                        <a class="button" @click="loadFiles"><span class="icon"><i class="fa fa-paperclip" aria-hidden="true"></i></span><span>Show Files ({{occurrence.files.length}})</span></a>
                      </template>
                      <template v-else>
                        <div class="columns is-multiline">
                          <div class="column is-12"><span style="font-weight: bold;"><i class="fa fa-paperclip" aria-hidden="true"></i> Attachments</span></div>
                          <template v-for="file in occurrence_files">
                            <div class="column is-12" style="text-align: center;">
                              <template v-if="file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg'">
                                <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                  <img :src="file['url']" alt="" width="90%">
                                </a>
                              </template>
                              <template v-else>
                                  <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                    <i class="fa fa-file-o fa-4" aria-hidden="true"></i>
                                    {{file['name']}}
                                  </a>
                              </template>
                            </div>
                            <div class="column is-12">
                              <article class="media">
                              </article>
                            </div>
                          </template>
                        </div>
                      </template>
                    </article>
                    <p>
                      <small class="is-pulled-right"><b>{{ occurrence.user.name }} ({{ occurrence.user.agency !== null ? occurrence.user.agency.name : (occurrence.user.base !== null ? occurrence.user.base.name : 'Sistema')}})</b> at <b>{{ occurrence.created_at }}</b></small>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <template v-for="(reply, index) in occurrence.replies">
              <template v-if="parseInt(reply.type) == 2">
                <template v-if="parseInt($store.state.config.user.level) < 4">
                  <div class="column is-12">
                    <div class="card is-fullwidth tip">
                      <header class="card-header is-primary" style="box-shadow: 0 1px 0px #2366d1, 0 0 0 0px #2366d1; background-color: #2366d1;">
                        <p class="card-header-title is-primary" style="color: #FFFFFF;">Internal Tip</p>
                      </header>
                      <div class="card-content">
                        <div class="content">
                          <pre>{{ reply.reply }}</pre>
                          <article class="media" v-if="reply.files.length > 0">
                          </article>
                          <article class="media" v-if="reply.files.length > 0">
                            <template v-if="reply.showFiles == false">
                              <a class="button" @click="loadFilesReply(reply, index)"><span class="icon"><i class="fa fa-paperclip" aria-hidden="true"></i></span><span>Show attachments ({{reply.files.length}})</span></a>
                            </template>
                            <template v-else>
                                <div class="columns is-multiline">
                                  <div class="column is-12"><span style="font-weight: bold;"><i class="fa fa-paperclip" aria-hidden="true"></i> Attachments</span></div>
                                  <template v-for="file in reply.files">
                                    <div class="column is-12" style="text-align: center;">
                                      <template v-if="file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg'">
                                        <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                          <img :src="file['url']" alt="" width="90%">
                                        </a>
                                      </template>
                                      <template v-else>
                                          <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                            <i class="fa fa-file-o fa-4" aria-hidden="true"></i>
                                            {{file['name']}}
                                          </a>
                                      </template>
                                    </div>
                                    <div class="column is-12">
                                      <article class="media">
                                      </article>
                                    </div>
                                  </template>
                                </div>
                            </template>
                          </article>
                          <p>
                            <small class="is-pulled-right"><b>{{ reply.user.name }}</b> at <b>{{ reply.created_at }}</b>
                            </small>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </template>
              <template v-else>
                <div class="column is-12">
                  <div class="card is-fullwidth">
                    <div class="card-content">
                      <div class="content">
                        <pre>{{ reply.reply }}</pre>
                        <article class="media" v-if="reply.files.length > 0">
                        </article>
                        <article class="media" v-if="reply.files.length > 0">
                          <template v-if="reply.showFiles == false">
                            <a class="button" @click="loadFilesReply(reply, index)"><span class="icon"><i class="fa fa-paperclip" aria-hidden="true"></i></span><span>Show attachments ({{reply.files.length}})</span></a>
                          </template>
                          <template v-else>
                              <div class="columns is-multiline">
                                <div class="column is-12"><span style="font-weight: bold;"><i class="fa fa-paperclip" aria-hidden="true"></i> Attachments</span></div>
                                <template v-for="file in reply.files">
                                  <div class="column is-12" style="text-align: center;">
                                    <template v-if="file['ext'].toLowerCase() == 'jpg' || file['ext'].toLowerCase() == 'gif' || file['ext'].toLowerCase() == 'png' || file['ext'].toLowerCase() == 'jpeg'">
                                      <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                        <img :src="file['url']" alt="" width="90%">
                                      </a>
                                    </template>
                                    <template v-else>
                                        <a :href="file['url']" target="_blank" style="border-bottom: none;">
                                          <i class="fa fa-file-o fa-4" aria-hidden="true"></i>
                                          {{file['name']}}
                                        </a>
                                    </template>
                                  </div>
                                  <div class="column is-12">
                                    <article class="media">
                                    </article>
                                  </div>
                                </template>
                              </div>
                          </template>
                        </article>
                        <p>
                          <small class="is-pulled-right"><b>{{ reply.user.name }}</b> at <b>{{ reply.created_at }}</b>
                          </small>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </template>
            <div class="column is-12" v-if="parseInt($store.state.config.user.level) < 4 || occurrence.status != 3">
              <div class="card is-fullwidth">
                <header class="card-header">
                  <p class="card-header-title is-primary">Reply</p>
                </header>
                <div class="card-content">
                  <div class="content">
                    <div class="control is-vertical">
                      <div class="control">
                        <textarea :class="{'textarea': true, 'is-danger': errors.has('reply') }" name="reply" id="reply" placeholder="" v-model="reply.reply" v-validate data-vv-rules="required"></textarea>
                        <span v-show="errors.has('reply')" class="help is-danger">{{ errors.first('reply') }}</span>
                      </div>
                      <!-- <vue-dropzone ref="myVueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone> -->
                    </div>
                    <div class="control is-grouped">
                      <p class="control is-expanded">
                        <vue-dropzone ref="dropzone" id="dropzone" :options="dropzoneOptions" @vdropzone-queue-complete="vdSuccess" @vdropzone-sending="vdSendingEvent"></vue-dropzone>
                      </p>
                    </div>
                    <p class="is-clearfix">
                      <a :class="{'button': true, 'is-info': true, 'is-pulled-left': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="internalTip" v-if="parseInt($store.state.config.user.level) < 4">Internal Tip</a>
                      <a :class="{'button': true, 'is-primary': true, 'is-pulled-right': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="replyOccurrence" v-if="occurrence.status != 3">Reply</a>
                      <a style="margin-right: 10px;" :class="{'button': true, 'is-danger': true, 'is-pulled-right': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" @click="replyCloseOccurrence" v-if="occurrence.status != 3 && parseInt($store.state.config.user.level) < 4">Reply/Close</a>
                      <a style="margin-right: 10px;" :class="{'button': true, 'is-warning': true, 'is-pulled-right': true, 'is-loading': inProgress, 'is-disabled': inProgress}" @click="replyAnalysis" v-if="occurrence.status < 3 && parseInt($store.state.config.user.level) < 4">Under Analysis</a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
  import vue2Dropzone from 'vue2-dropzone'
  import 'vue2-dropzone/dist/vue2Dropzone.min.css'
  import message from '../../utils/message'
  import Service from '../../components/services/Service.vue'
  import OccurrencesSimple from '../../components/occurrences/OccurrencesSimple.vue'
  import Financial from '../../components/services/Financial.vue'
  import Dispute from '../../components/services/Dispute.vue'
  export default {
    data () {
      return {
        occurrence: null,
        reply: {
          occurrence_id: '',
          reply_id: '',
          reply: '',
          close: false,
          internal: false,
          analysis: false,
          attachments: 0
        },
        inProgress: false,
        dropzoneOptions: {
          url: this.$store.state.config.apiURL + '/occurrences/reply/files',
          maxFilesize: 10,
          acceptedFiles: 'image/*,application/pdf,.doc,.docx,.csv,.xls,.xlsx,.txt,.eml,.log,.xml,.json',
          autoProcessQueue: false,
          dictDefaultMessage: 'Upload Files (max size 10MB)',
          headers: {
            'Authorization': 'Bearer ' + this.$store.state.config.token.access_token
          },
          addRemoveLinks: true
        },
        showFiles: false,
        occurrence_files: []
      }
    },
    components: {
      Service,
      OccurrencesSimple,
      Financial,
      Dispute,
      vueDropzone: vue2Dropzone
    },
    watch: {
      '$route' (to, from) {
        this.loadData()
      }
    },
    mounted () {
      this.$nextTick(() => {
        this.loadData()
      })
    },
    methods: {
      clearReply () {
        this.reply.reply_id = ''
        this.reply.reply = ''
        this.reply.close = false
        this.reply.internal = false
        this.reply.analysis = false
        this.inProgress = false
        this.$validator.reset()
        this.$refs.dropzone.removeAllFiles(true)
        this.loadData()
      },
      loadData () {
        this.$http.get(this.$store.state.config.apiURL + '/occurrences_customer/' + this.$route.params.id).then((response) => {
          this.occurrence = response.body
          this.reply.occurrence_id = this.occurrence.id
        }, (response) => {
          let propsData = {
            title: 'Error',
            message: response.body,
            type: 'danger',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          message.openMessage(propsData)
        })
      },
      loadFiles () {
        this.$http.get(this.$store.state.config.apiURL + '/occurrences/files', {params: {'occurrence_id': this.occurrence.id}}).then((response) => {
          this.occurrence_files = response.body
          this.showFiles = true
        }, (response) => {
        })
      },
      loadFilesReply (reply, index) {
        this.$http.get(this.$store.state.config.apiURL + '/occurrences/reply/files', {params: {'occurrence_id': this.occurrence.id, 'reply_id': reply.id}}).then((response) => {
          this.occurrence.replies[index].files = response.body
          this.occurrence.replies[index].showFiles = true
        }, (response) => {
        })
      },
      vdSuccess (file, xhr, formData) {
        this.$emit('reload')
        if (this.reply.close) {
          this.message('success', 'Success', 'The reply successfully registered and occurrence closed')
        } else if (this.reply.internal) {
          this.message('success', 'Success', 'The internal tip was successfully registered')
        } else {
          this.message('success', 'Success', 'The reply successfully registered')
        }
        this.clearReply()
      },
      vdSendingEvent (file, xhr, formData) {
        formData.append('occurrence_id', this.reply.occurrence_id)
        formData.append('reply_id', this.reply.reply_id)
      },
      replyOccurrence () {
        this.$validator.validateAll()
        if (this.$validator.errorBag.errors.length === 0) {
          this.inProgress = true
          this.reply.close = false
          this.reply.internal = false
          this.reply.analysis = false
          if (this.$refs.dropzone.getQueuedFiles().length > 0) {
            this.reply.attachments = 1
          }
          this.$http.post(this.$store.state.config.apiURL + '/occurrences_generic_customer_reply', this.reply).then((response) => {
            this.reply.reply_id = response.body.id
            if (this.$refs.dropzone.getQueuedFiles().length > 0) {
              this.$refs.dropzone.processQueue()
            } else {
              this.message('success', 'Success', 'The reply successfully registered')
              this.clearReply()
            }
          }, (response) => {
            this.inProgress = false
            this.message('danger', 'Error', response.body)
          })
        }
      },
      replyCloseOccurrence () {
        if (window.confirm('Are you sure you want to close this ticket?')) {
          this.$validator.validateAll()
          if (this.$validator.errorBag.errors.length === 0) {
            this.inProgress = true
            this.reply.close = true
            this.reply.internal = false
            this.reply.analysis = false
            if (this.$refs.dropzone.getQueuedFiles().length > 0) {
              this.reply.attachments = 1
            }
            this.$http.post(this.$store.state.config.apiURL + '/occurrences_generic_customer_reply', this.reply).then((response) => {
              this.reply.reply_id = response.body.id
              if (this.$refs.dropzone.getQueuedFiles().length > 0) {
                this.$refs.dropzone.processQueue()
              } else {
                this.message('success', 'Success', 'The reply successfully registered and occurrence closed')
                this.clearReply()
              }
            }, (response) => {
              this.inProgress = false
              this.message('danger', 'Error', response.body)
            })
          }
        } else {
          this.inProgress = false
        }
      },
      internalTip () {
        this.$validator.validateAll()
        if (this.$validator.errorBag.errors.length === 0) {
          this.inProgress = true
          this.reply.close = false
          this.reply.internal = true
          this.reply.analysis = false
          if (this.$refs.dropzone.getQueuedFiles().length > 0) {
            this.reply.attachments = 1
          }
          this.$http.post(this.$store.state.config.apiURL + '/occurrences_generic_customer_reply', this.reply).then((response) => {
            this.reply.reply_id = response.body.id
            if (this.$refs.dropzone.getQueuedFiles().length > 0) {
              this.$refs.dropzone.processQueue()
            } else {
              this.message('success', 'Success', 'The internal tip was successfully registered')
              this.clearReply()
            }
          }, (response) => {
            this.inProgress = false
            this.message('danger', 'Error', response.body)
          })
        }
      },
      replyAnalysis () {
        this.inProgress = true
        this.reply.close = false
        this.reply.internal = false
        this.reply.analysis = true
        this.reply.reply = 'Em analise'
        this.$http.post(this.$store.state.config.apiURL + '/occurrences_generic_customer_reply', this.reply).then((response) => {
          this.message('success', 'Success', 'The internal tip was successfully registered')
          this.clearReply()
        }, (response) => {
          this.inProgress = false
          this.message('danger', 'Error', response.body)
        })
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      parseDepartament (departament) {
        return this.$store.state.config.departaments[departament].name
      },
      parseStatus (status) {
        return this.$store.state.config.status[status].name
      }
    }
  }
</script>

<style lang="scss" scoped>
  .is-title {
    text-transform: capitalize;
  }

  pre {
    background-color: #FFFFFF;
    white-space: -moz-pre-wrap; /* Mozilla, supported since 1999 */
    white-space: -pre-wrap; /* Opera */
    white-space: -o-pre-wrap; /* Opera */
    white-space: pre-wrap; /* CSS3 - Text module (Candidate Recommendation) http://www.w3.org/TR/css3-text/#white-space */
    word-wrap: break-word; /* IE 5.5+ */
    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Oxygen, Ubuntu, Cantarell, Fira Sans, Droid Sans, Helvetica Neue, Helvetica, Arial, sans-serif;
    color: #4a4a4a;
    font-size: 1rem;
    font-weight: 400;
  }

  .tip {
    box-shadow: 0 2px 3px #2366d1, 0 0 0 1px #2366d1;
  }

  #customdropzone {
    background-color: orange;
    font-family: 'Arial', sans-serif;
    letter-spacing: 0.2px;
    color: #777;
    transition: background-color .2s linear;
    height: 200px;
    padding: 40px;
  }

  #customdropzone .dz-preview {
    width: 160px;
    display: inline-block
  }
 #customdropzone .dz-preview .dz-image {
    width: 80px;
    height: 80px;
    margin-left: 40px;
    margin-bottom: 10px;
  }
  #customdropzone .dz-preview .dz-image > div {
    width: inherit;
    height: inherit;
    border-radius: 50%;
    background-size: contain;
  }
  #customdropzone .dz-preview .dz-image > img {
    width: 100%;
  }

   #customdropzone .dz-preview .dz-details {
    color: white;
    transition: opacity .2s linear;
    text-align: center;
  }
  #customdropzone .dz-success-mark, .dz-error-mark, .dz-remove {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// OccurrenceGeneric.vue?43f2b4a0